import React, { Component } from 'react';
import { authenticationCentral } from '../authentication/Authentication';
import { storage, TOKEN_INFO, TOKEN_EXPIRATION, PROFILE_INFO, REDIRECT_TO } from '../app/Storage';

export class LoginPage extends Component {
    componentDidMount() {
        storage.set(REDIRECT_TO, window.location.href);
        if (authenticationCentral.isLoggedIn && authenticationCentral.isTokenExpired) {
            authenticationCentral.refreshToken()
                .then((res) => {
                    // Redirect to the homepage
                    // FIXME there must be a better way to redirect to the homepage
                    let redirectTo = storage.get(REDIRECT_TO);
                    storage.remove(REDIRECT_TO);
                    if (redirectTo !== undefined) {
                        window.location.href = redirectTo;
                    } else {
                        window.location.href = '/';
                    }
                }).catch((error) => {
                    // Could not refresh token 
                    // Should erase all login information and start over
                    storage.remove(TOKEN_INFO);
                    storage.remove(TOKEN_EXPIRATION);
                    storage.remove(PROFILE_INFO);
                    storage.remove(REDIRECT_TO);

                    // FIXME Show whatever error was received to the user                    
                    window.location.href = "/";
                    throw error;
                });
        }
        else if (authenticationCentral.isLoggedIn && authenticationCentral.shouldCheckSession) {
            window.location.href = authenticationCentral.sessionCheckUrl;
        }
        else {
            window.location.href = authenticationCentral.signInUrl;
        }
    }

    render() {
        return (
            <div />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginPage.js